module.exports = __webpack_public_path__ + "img/b_17_s.b64a235a.jpg";